import ko from 'knockout';

function VideoViewModel(video) {
    this.url = ko.observable(video.url);
    this.title = ko.observable(video.title);
    this.description = ko.observable(cleanVideoData(video.description));
    this.thumbnail = ko.observable(updateThumbnailToCustomImage(video.thumbnail));

    var querystring = smartPak.url.parseQueryString(location.search);

    if (querystring && querystring.video && new RegExp(querystring.video).test(this.url())) {
        this.showVideo(this);
    }
}

VideoViewModel.prototype.showVideo = function(video) {
    import('../../../smartpak/ui').then(({showVideo}) => showVideo(video.url()));    

    return false;
};

function removeLineBreaks(text) {
    return text.replace(/\r?\n|\r/g, ' ');
}

function removeURLs(text) {
    return text
        .replace(/\(http([^()]*)\)/g, '')
        .replace(/(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g, '');
}

function cleanVideoData(description) {
    return $.trim(removeLineBreaks(removeURLs(description)));
}

function updateThumbnailToCustomImage(image) {
    return image.replace(/3\.jpg/gi, '0.jpg');
}

export default VideoViewModel;
